import { Box, Container } from '@chakra-ui/react';
import { PrimaryButton } from './Button';

import dotPattern from '../../public/images/resources/dot-pattern.svg';

import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const signUpUrl = publicRuntimeConfig.signUpUrl;

export default function BlueCTA({ type }: { type: string }) {
  return (
    <Box p={{ base: '3.2rem 0', lg: '4rem 0 ' }} bgColor="#475F7A" color="#fff" position="relative">
      <Box
        w="6.25rem"
        h="100%"
        position="absolute"
        top="0"
        left="0"
        bgImage={`url(${dotPattern.src})`}
      />
      <Container>
        <Box maxW="43.125rem" ml="auto" mr="auto" textAlign="center">
          <Box
            mb={{ base: '0.8rem', lg: '1rem' }}
            fontSize={{ base: '1.2rem', lg: '1.5rem' }}
            lineHeight={{ base: '1.4rem', lg: '1.75rem' }}
            fontWeight="700"
          >
            {type === 'engineers'
              ? 'Looking for your next high-growth career opportunity?'
              : 'Get in touch with a Terminal expert and find out how to scale your remote team for success'}
          </Box>
          <Box fontSize="0.9375rem" lineHeight="1.5rem" mb={{ base: '1.6rem', lg: '2rem' }}>
            {type === 'engineers'
              ? 'Check out fully remote positions with the most innovative US tech companies'
              : 'Terminal is a remote teams engine for fast-growing companies. This means we hire, house, develop, and retain engineering teams — so that you can focus on building brilliant products.'}
          </Box>
          <PrimaryButton href={type === 'engineers' ? signUpUrl : '/contact'}>
            Get Started
          </PrimaryButton>
        </Box>
      </Container>
    </Box>
  );
}
